import JobAppMutations from "./jobApp/jobApp.mutation";
import JobAppQueries from "./jobApp/jobApp.query";

const JobAppServices = {
  ...JobAppQueries,
  ...JobAppMutations,
};

export default JobAppServices;
